'use strict';

/* globals RELATIVE_PATH, document, $, bootbox */

require([RELATIVE_PATH + '/plugins/nodebb-plugin-surveys/static/vendor/vue.js'], function (Vue) {
	Vue.component('survey-question', {
		props: ['question', 'answered'],
		template: 
		'<div class="lesson-question-view">' +
			'<div class="lesson-question">{{question.question}}</div>' +
			'<div class="lesson-answers">' +
				'<div class="row">' +
					'<answers-view :answers="question.answers" :answered="answered"></answers-view>' +
				'</div>' +
			'</div>' +
		'</div>',
	});
});
